var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "featured_posts_listing" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "header",
          { staticClass: "header-desktop" },
          [
            _vm.title
              ? _c("h3", { domProps: { innerHTML: _vm._s(_vm.title) } })
              : _vm._e(),
            _vm._v(" "),
            _c("tertiary-button", {
              attrs: {
                link: _vm.parsedCta ? _vm.parsedCta : _vm.parsedCta.link,
                label: _vm.parsedCta.title
                  ? _vm.parsedCta.title
                  : _vm.parsedCta.link
                  ? _vm.parsedCta.link.title
                  : "_self",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.no_slider === "true"
          ? _vm._l(_vm.parsedPageLinks, function (tile, index) {
              return _c("post-tile", {
                key: index,
                staticClass: "featured_post",
                attrs: {
                  name: tile.title,
                  short_description: tile.description,
                  image: tile.image ? tile.image.url : null,
                  permalink: {
                    url: tile.url,
                    target: "_self",
                    title: tile.title,
                  },
                  tag: tile.category,
                  post_type: tile.post_type,
                },
              })
            })
          : [
              _c("div", { staticClass: "slider-slider" }, [
                _c("div", { staticClass: "swiper", class: _vm.section_id }, [
                  _c(
                    "div",
                    { staticClass: "swiper-wrapper" },
                    [
                      _vm.type === "post"
                        ? _vm._l(_vm.parsedPageLinks, function (tile, index) {
                            return _c("post-tile", {
                              key: index + "_standard",
                              staticClass: "swiper-slide featured_post",
                              attrs: {
                                name: tile.title,
                                short_description: tile.description,
                                image: tile.image ? tile.image.url : null,
                                permalink: {
                                  url: tile.url,
                                  target: "_self",
                                  title: tile.title,
                                },
                                tag: tile.category,
                                post_type: tile.type,
                              },
                            })
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  Object.keys(_vm.parsedPageLinks).length > 4
                    ? _c("div", {
                        staticClass: "swiper-pagination",
                        class: "swiper-pag-" + _vm.section_id,
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  Object.keys(_vm.parsedPageLinks).length > 4
                    ? _c(
                        "div",
                        { staticClass: "swiper-next-prev" },
                        [
                          _c("carousel-arrow", {
                            staticClass: "swiper-button-prev swiper-button-prv",
                            class: "swiper-button-prev-" + _vm.section_id,
                            attrs: { direction: "prev", theme: "dark" },
                          }),
                          _vm._v(" "),
                          _c("carousel-arrow", {
                            staticClass: "swiper-button-next swiper-button-nxt",
                            class: "swiper-button-next-" + _vm.section_id,
                            attrs: { direction: "next", theme: "dark" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }